import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchGuide, fetchGuideCreate, editGuide,
} from "Actions/Admin/Program/GuideActions";



/**
 * The Program Guide Edit Dialog
 */
class GuideEdit extends React.Component {
    // The Initial Data
    initialData = {
        programGuideID : 0,
        programID      : 0,
        guideID        : 0,
        classID        : 0,
        position       : 0,
        status         : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, programID, position, fetchGuide, fetchGuideCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchGuide(elemID);
                loading = true;
            // Load edit data
            } else if (programID) {
                fetchGuideCreate(programID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, programID, position };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editGuide(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose, guides, classes } = this.props;
        const { data, loading, errors                  } = this.state;

        return <EditDialog
            open={open}
            icon="guide"
            title={!!elemID ? "GUIDES_EDIT_TITLE" : "GUIDES_ASSIGN_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                type="select"
                name="guideID"
                label="GUIDES_SINGULAR"
                value={data.guideID}
                error={errors.guideID}
                onChange={this.handleChange}
                options={guides}
                withNone
                isRequired
            />
            <InputField
                type="select"
                name="classID"
                label="GUIDES_CLASS"
                value={data.classID}
                error={errors.classID}
                onChange={this.handleChange}
                options={classes}
                withNone
                isRequired
            />
            <Columns>
                <InputField
                    type="number"
                    name="position"
                    label="GENERAL_POSITION"
                    value={data.position}
                    error={errors.position}
                    onChange={this.handleChange}
                    shrinkLabel
                />
                <InputField
                    type="select"
                    name="status"
                    label="GENERAL_STATUS"
                    value={data.status}
                    error={errors.status}
                    onChange={this.handleChange}
                    options={Status.getFemSelect()}
                    withNone
                    isRequired
                    shrinkLabel
                />
            </Columns>
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchGuide       : PropTypes.func.isRequired,
        fetchGuideCreate : PropTypes.func.isRequired,
        editGuide        : PropTypes.func.isRequired,
        open             : PropTypes.bool.isRequired,
        onClose          : PropTypes.func.isRequired,
        onSubmit         : PropTypes.func.isRequired,
        edition          : PropTypes.number.isRequired,
        position         : PropTypes.number.isRequired,
        guides           : PropTypes.array.isRequired,
        classes          : PropTypes.array.isRequired,
        elem             : PropTypes.object.isRequired,
        elemID           : PropTypes.number,
        programID        : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition  : state.programGuide.edition,
            position : state.programGuide.position,
            guides   : state.programGuide.guides,
            classes  : state.programGuide.classes,
            elem     : state.programGuide.elem,
        };
    }
}

export default connect(GuideEdit.mapStateToProps, {
    fetchGuide, fetchGuideCreate, editGuide,
})(GuideEdit);
